/**
 * localStorage utilities for persisting MQTT configuration
 */

import { MQTTConfig } from '../types/mqtt';

const MQTT_CONFIG_KEY = 'mqtt_config';
const AUTOMATION_CONFIG_KEY = 'automation_config';

export const storage = {
  // MQTT Config
  saveMQTTConfig: (config: MQTTConfig): void => {
    try {
      localStorage.setItem(MQTT_CONFIG_KEY, JSON.stringify(config));
    } catch (error) {
      console.error('Failed to save MQTT config:', error);
    }
  },

  loadMQTTConfig: (): MQTTConfig | null => {
    try {
      const stored = localStorage.getItem(MQTT_CONFIG_KEY);
      if (stored) {
        return JSON.parse(stored) as MQTTConfig;
      }
    } catch (error) {
      console.error('Failed to load MQTT config:', error);
    }
    return null;
  },

  clearMQTTConfig: (): void => {
    try {
      localStorage.removeItem(MQTT_CONFIG_KEY);
    } catch (error) {
      console.error('Failed to clear MQTT config:', error);
    }
  },

  // Automation Config
  saveAutomationConfig: (config: { enabled: boolean; mode: string }): void => {
    try {
      localStorage.setItem(AUTOMATION_CONFIG_KEY, JSON.stringify(config));
    } catch (error) {
      console.error('Failed to save automation config:', error);
    }
  },

  loadAutomationConfig: (): { enabled: boolean; mode: string } | null => {
    try {
      const stored = localStorage.getItem(AUTOMATION_CONFIG_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.error('Failed to load automation config:', error);
    }
    return null;
  },
};

